import Vue from 'vue'
import Router from 'vue-router'
// eslint-disable-next-line no-unused-vars
import HelloWorld from '@/components/HelloWorld'
import Sign from '@/views/Sign'
import SignSuccess from '@/views/SignSuccess'
import Reg from '@/views/Reg'
import RegSuccess from '@/views/RegSuccess'
import Message from '@/views/Message'
import Signature from '@/views/Signature'
import Voip from '@/views/Voip'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // 打包发布到服务器需要解开，本地运行则需要注释掉
  base: '/front/',
  routes: [
    {
      path: '/',
      name: 'RegIndex',
      component: Reg
    },
    {
      path: '/Sign/:id',
      name: 'Sign',
      component: Sign
    },
    {
      path: '/Sign/:id/:channel/:activityName',
      name: 'SignChannel',
      component: Sign
    },
    {
      path: '/Sign/:channel/:activityName',
      name: 'SignChannel',
      component: Sign
    },
    {
      path: '/SignSuccess/:id/:channel/:activityName',
      name: 'SignSuccess',
      component: SignSuccess
    },
    {
      path: '/SignSuccess/:channel/:activityName',
      name: 'SignSuccess',
      component: SignSuccess
    },
    {
      path: '/Reg/:id',
      name: 'Reg',
      component: Reg
    },
    {
      path: '/Reg/:id/:channel/:activityName',
      name: 'RegChannel',
      component: Reg
    },
    {
      path: '/Reg/:channel/:activityName',
      name: 'RegChannel',
      component: Reg
    },
    {
      path: '/RegSuccess/:id/:channel/:activityName',
      name: 'RegSuccess',
      component: RegSuccess
    },
    {
      path: '/RegSuccess/:channel/:activityName',
      name: 'RegSuccess',
      component: RegSuccess
    },
    {
      path: '/Voip',
      name: 'Voip',
      component: Voip
    },
    {
      path: '/Message',
      name: 'Message',
      component: Message
    },
    {
      path: '/Signature',
      name: 'Signature',
      component: Signature
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js